var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 3H3.4c-1 0-1.8.8-1.8 1.8v7c0 1 .8 1.8 1.6 1.8v13c0 1 .8 1.8 1.8 1.8h21.8c1 0 1.8-.8 1.8-1.8v-13c1 0 1.6-.8 1.6-1.8v-7c.2-1-.6-1.8-1.6-1.8M5.2 6.7H27v3.6H5.2zm1.6 18.2V13.6h18.4v11.2s-18.4 0-18.4.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 15.4h-5.2c-.8 0-1.6.8-1.6 1.8s.8 1.8 1.8 1.8h5c1 0 1.8-.8 1.8-1.8s-1-1.8-1.8-1.8"
  })));
};
export default SvgArchive;